import { BillingFrequency } from '../../../../../__generated__/sharedTypes.js';
import { SubscriptionType } from '../../../../../models/subscription/subscription-details.js';

const getSubscriptionType = (typeDetails)=>{
    if (typeDetails.billingFrequency.valueOf() === typeDetails.deliveryFrequency.valueOf()) {
        if (typeDetails.billingFrequency === BillingFrequency.MONTHLY) {
            return SubscriptionType.MONTHLY;
        }
        return SubscriptionType.QUARTERLY;
    }
    if (typeDetails.billingFrequency === BillingFrequency.MONTHLY) {
        return SubscriptionType.MIXED_MONTHLY;
    }
    return SubscriptionType.MIXED_QUARTERLY;
};

export { getSubscriptionType };
//# sourceMappingURL=get-subscription-type.js.map
